export default function RiskProfileModal() {
    return (
        <dialog
            id="riskProfileDetails"
            className="ps-4 pe-4"
            style={{ width: "60%" }}
        >
            <img
                src={`/image/galina-mountain-hike.jpg`}
                className="card-img-top"
                alt="World Map"
            />
            <h5 className="card-title pt-3 pb-2">Risk Profiles</h5>

            <div className="risk-profile-container p-3">
                <div className="risk-level safe row mb-3">
                    <div className="col-md-3 col-sm-12 d-flex align-items-center justify-content-center bg-success">
                        <h6 className="mb-0">Safe</h6>
                    </div>
                    <div className="col-md-9 col-sm-12">
                        <p className="text-start">
                            Areas classified as Safe have minimal security
                            concerns. These locations typically feature low
                            crime rates, stable political environments, and
                            reliable infrastructure. Travelers can move about
                            freely with standard precautions.
                        </p>
                    </div>
                </div>

                <div className="risk-level okay row mb-3">
                    <div className="col-md-3 col-sm-12 d-flex align-items-center justify-content-center bg-info">
                        <h6 className="mb-0">Okay</h6>
                    </div>
                    <div className="col-md-9 col-sm-12">
                        <p className="text-start">
                            Okay areas present moderate risk factors that are
                            manageable with basic awareness. While generally
                            secure, travelers should remain alert to their
                            surroundings, follow local guidelines, and take
                            common-sense safety measures.
                        </p>
                    </div>
                </div>

                <div className="risk-level caution row mb-3">
                    <div className="col-md-3 col-sm-12 d-flex align-items-center justify-content-center bg-warning">
                        <h6 className="mb-0">Caution</h6>
                    </div>
                    <div className="col-md-9 col-sm-12">
                        <p className="text-start">
                            Locations marked as Caution require heightened
                            vigilance and preparation. These areas may
                            experience periodic instability, higher crime rates
                            in certain districts, or environmental concerns. We
                            recommend thorough research and planning before
                            visiting.
                        </p>
                    </div>
                </div>

                <div className="risk-level danger row mb-3">
                    <div className="col-md-3 col-sm-12 d-flex align-items-center justify-content-center bg-danger">
                        <h6 className="mb-0">Danger</h6>
                    </div>
                    <div className="col-md-9 col-sm-12">
                        <p className="text-start">
                            Danger zones indicate significant safety concerns
                            that may include active emergencies, ongoing
                            conflict, political unrest, high crime rates,
                            natural disasters, or health emergencies. Travel to
                            these areas should be carefully considered or
                            potentially avoided unless necessary, with
                            comprehensive safety protocols in place.
                        </p>
                    </div>
                </div>
            </div>
            <p>
                <em>
                    While the above classifications are based on detailed
                    calculations and probabilities, always remember that danger
                    can be unpredictable. <br />
                    We recommend that you stay alert and cautious, regardless of
                    the risk assessment.
                </em>
            </p>
            <hr className="mt-4 mb-4"></hr>
            <button
                className="btn btn-outline-secondary"
                autoFocus
                onClick={() => {
                    const riskProfileDialog =
                        document.getElementById("riskProfileDetails")
                    if (riskProfileDialog) {
                        riskProfileDialog.close()
                    }
                }}
            >
                Close
            </button>
        </dialog>
    )
}
